import { SHStack, SHTypography } from "@components/design-systems";
import { FilterSVG } from "@components/svgs";
import React from "react";
import { Column } from "@tanstack/react-table";
import { ModelScreenerRow } from "@models/model-screener/entities/modelScreenerData";
import { useTheme } from "@mui/material";
import { ModelScreenerFilterType } from "@models/model-screener/enums/filterType";
import { MSTableFilterComponentMap } from "@pages/managed-accounts/model-screener/constant";

export type MSTableFilterColumnMenuProps = {
  column: Column<ModelScreenerRow, any>;
};

export const MSTableFilterMenu = ({ column }: MSTableFilterColumnMenuProps) => {
  const { palette } = useTheme();

  const isCanSort = column.getCanSort();
  const metaData = column.columnDef.meta;
  const filterType: ModelScreenerFilterType =
    metaData?.filterType as ModelScreenerFilterType;

  const FilterComponent = MSTableFilterComponentMap[filterType];

  return !!filterType ? (
    <SHStack
      sx={{
        paddingY: 0.75,
        paddingX: 2,
        borderWidth: 0,
        borderTopWidth: isCanSort ? 1 : 0,
        borderColor: palette.divider,
        borderStyle: "solid",
      }}
    >
      <SHStack spacing={1} direction="row" alignItems="center">
        <FilterSVG />
        <SHTypography variant="body1">Filter</SHTypography>
      </SHStack>

      <SHStack
        sx={{
          maxHeight: "300px",
          overflowY: "auto",
          paddingLeft: "15px",
        }}
      >
        <FilterComponent column={column} />
      </SHStack>
    </SHStack>
  ) : null;
};
